import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

type NoteValue = "has_note" | "no_note" | "requires_note";

const options: FilterMultiselectOption[] = [
    { value: "has_note", label: "Has memo", searchableLabel: "has memo" },
    { value: "no_note", label: "No memo", searchableLabel: "no memo" },
    {
        value: "requires_note",
        label: "Requires memo",
        searchableLabel: "requires memo",
    },
];

export const NoteFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value: NoteValue[] = [
        ...(filters.hasNote ? ["has_note" as const] : []),
        ...(filters.noNote ? ["no_note" as const] : []),
        ...(filters.requiresNote ? ["requires_note" as const] : []),
    ];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val as NoteValue[];
                    onChange({
                        hasNote: selected.includes("has_note")
                            ? true
                            : undefined,
                        noNote: selected.includes("no_note") ? true : undefined,
                        requiresNote: selected.includes("requires_note")
                            ? true
                            : undefined,
                    });
                }}
                name="memo"
                onBlur={noop}
            />
        </div>
    );
};
